/**
 * Module dependencies.
 */

import { FadeInUp } from 'components/atoms/in-view-once/fade-in-up';
import {
  Image,
  ProductContent,
  ProductDescription,
  ProductTitle,
  ProductWrapper,
} from './product-list.style';

import { InViewOnce } from 'components/atoms/in-view-once/in-view-once';
import { JSX, useMemo } from 'react';
import { Link } from 'components/atoms/link/link';
import { snakeCase } from 'lodash';
import { useTranslation } from 'next-i18next';

/**
 * `Props` type.
 */

type Props = {
  category: any;
  product: any;
  subCategory: any;
};

/**
 * Export `Product` component.
 */

export function Product(props: Props): JSX.Element {
  const { category, product, subCategory } = props;
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const link = useMemo(() => {
    let link = '/catalog';

    link = `${link}/${category.id}-${snakeCase(category.title[lang])}`;
    link = `${link}/${subCategory.id}-${snakeCase(subCategory.title[lang])}`;
    link = `${link}/${product.id}-${snakeCase(product.name[lang])}`;

    return link;
  }, [
    category.id,
    category.title,
    lang,
    product.id,
    product.name,
    subCategory.id,
    subCategory.title,
  ]);

  return (
    <Link ghost href={link}>
      <ProductWrapper>
        <InViewOnce AnimationComponent={FadeInUp}>
          <Image image={product.thumb ?? product.image} />
        </InViewOnce>

        <ProductContent>
          <ProductTitle>{product.name[lang]}</ProductTitle>

          <ProductDescription>{product.description[lang]}</ProductDescription>
        </ProductContent>
      </ProductWrapper>
    </Link>
  );
}
